<template>
    
      <b-card>
        <b-row>
          <div style="position:absolute; top:10px; right:25px;">
            <span style="display:inline-block" class="mr-2">
              <b-form-select v-model="reqStatsFilters.salesRep" @change="onGetRequirementStatus" class="mb-2">
                <option :value="null"> -- All Sales Rep -- </option>
                <option v-for="(rep, i) in salesReps" :key="i" :value="rep.id">{{rep.name}} </option>
              </b-form-select>
            </span>
            <span style="display:inline-block">
              <b-form-select :value="reqStatsSelectedDateRange" @change="onDateRangeChange" class="mb-2 mr-2">
                <option :value="null">All</option>
                <option v-for="(type) in dateRangeTypes" :key="type" :value="type">  
                  {{type}}
                </option>
              </b-form-select> 
            </span>
          </div>
          <b-modal size="sm" title="Custom Date for Req Status" id="custom-date-req-stats" @ok="onCustomSet" no-close-on-backdrop>
            <div style="display:flex; flex-direction: row; justify-content: center; top: 0;">
              <!-- v-if="reqStatsSelectedDateRange === dateRangeTypes.CUSTOM" -->
            <b-form-group label="From"  class="mb-4 mr-2" >
              <date-picker v-model="reqStatsFilters.dateFrom" :config="datePickerOptions" size="sm" />
            </b-form-group>
            <b-form-group label="To" class="mb-4">
              <date-picker v-model="reqStatsFilters.dateTo" :config="datePickerOptions" size="sm" />
            </b-form-group>
            </div>          
          </b-modal>    
        </b-row>
        <br/>
        <div>
          <apex-chart chartType="donut" :chartOptions="chartOptions" :chartSeries="chartSeries" />
        </div>
      </b-card>  
</template>

<script>
  import ApexChart from './../extensions/ApexChart'
  import { ACTIVE, REQUEST_DATE, DATE_FORMAT, SEARCH_DEBOUNCE_TIME } from '@/shared/constants';
  import { getDatesFromRangeString, dateToDay, generateListofDates } from '@/shared/helpers';
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

  export default {
    components: {
      ApexChart
    },
    data () {
      return {
        dateRangeTypes: REQUEST_DATE,
        datePickerOptions: {
          format: DATE_FORMAT,
          useCurrent: false,
        },
        componentKey: 0,
        isLoadingWidget: true,
        chartOptions: {},
        chartSeries: [],
      }
    },
    computed: {
      ...mapGetters('account', ['userId']),
      ...mapState('salesReps', ['salesReps']),
      ...mapGetters('dashboard', ['reqStatsSelectedDateRange', 'reqStatsFilters']),
    }, 
    methods: {
      ...mapActions('dashboard', ['getRequirementStatus']),
      ...mapMutations('dashboard', ['setItem']),
      onDateRangeChange(value) { 
        if (value === REQUEST_DATE.CUSTOM) {
          this.reqStatsFilters.dateFrom = null;
          this.reqStatsFilters.dateTo= null;
          this.$bvModal.show('custom-date-req-stats');
        } else if (value == null) {
          this.reqStatsFilters.dateFrom = null;
          this.reqStatsFilters.dateTo= null;
          this.onGetRequirementStatus();
        } else {
          const { dateFrom, dateTo } = getDatesFromRangeString(value);
          this.setDefaults();
          this.reqStatsFilters.dateFrom = dateFrom;
          this.reqStatsFilters.dateTo= dateTo;
          this.onGetRequirementStatus();
        }

        this.setItem({ resource: 'reqStatsSelectedDateRange', payload: value });
      },
      onCustomSet() {
        if (this.reqStatsFilters.dateFrom && this.reqStatsFilters.dateTo) {
          this.setDefaults();
          this.onGetRequirementStatus();
          
        }
        this.$bvModal.hide('custom-date-req-stats');
      },
      async onGetRequirementStatus() {
        this.isLoadingWidget = true;

        await this.getRequirementStatus(this.reqStatsFilters).then((res) => { 
          // let amountSeries = res.map(x => x.salesAmount)
          this.chartSeries = res.map(x => x.statusCount)
          this.chartOptions = {
              ...this.chartOptions,
              noData: {
                  text: (res.length > 0) ? '' : 'No available data'
              },
              labels: res.map(x => x.statusName),
              plotOptions: {
                pie: {
                  donut: {
                    labels: {
                      show: true,
                      total: {
                        showAlways: true,
                        show: true
                      }
                    }
                  }    
                }
              }
              
          }
          
          this.isLoadingWidget = false;
        });
      },
      setDefaults() {
          this.chartOptions = { 
            chart: {
                id: 'requirement-statuses-donut',
                type: 'donut'
            },
            title: {
                text: 'Requirements Statuses'
            },
            noData: {
                text: 'Fetching data...'
            },
            responsive: [
              {
                options: {
                  chart: {
                    width: 50
                  },
                  legend: { position: 'bottom'}
                }
              }
            ],
            colors: [function({ value, seriesIndex, w }) {
              if (w.globals.labels[seriesIndex] == 'New') {
                 return '#008FFB'
              } else if (w.globals.labels[seriesIndex] == 'Sent') {
                return '#4ECDC4'
              } else if (w.globals.labels[seriesIndex] == 'Sourced') {
                return '#43BCCD';
              } else if (w.globals.labels[seriesIndex] == 'Quoted') {
                return '#FF9800';
              } else if (w.globals.labels[seriesIndex] == 'Sold') {
                return '#00E396';
              } else if (w.globals.labels[seriesIndex] == 'Replaced') {
                return '#F86624';
              }  else if (w.globals.labels[seriesIndex] == 'Cancelled') {
                return '#D4526E';
              }  else {
                  return '#C4BBAF'
              }
            }],
            dataLabels: {
                enabled: true,
                formatter(val, opts) {
                  return [opts.w.globals.labels[opts.seriesIndex],opts.w.globals.series[opts.seriesIndex]];
                }
              }
          };
          this.chartSeries = [];
      }
    },
    mounted () {
      if (this.reqStatsSelectedDateRange == REQUEST_DATE.CUSTOM)
        this.setItem({ resource: 'reqStatsSelectedDateRange', payload: REQUEST_DATE.THIS_YEAR });

      const { dateFrom, dateTo } = getDatesFromRangeString(this.reqStatsSelectedDateRange);
      this.setDefaults();
      this.reqStatsFilters.dateFrom = dateFrom;
      this.reqStatsFilters.dateTo= dateTo;
      this.onGetRequirementStatus();
    },
  }
</script>

<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>